module.exports = __webpack_public_path__ + "img/home_banner_2.84afe465.png";